import classNames from 'classnames';
import {
  ToastContainer as ToastifyToastContainer,
} from 'react-toastify';

// icons
import CloseIcon from '@svg/close.svg';

// styles
import s from './ToastContainer.sss';

// constants
export enum NotifyType {
  Success,
  Error,
}

export const themes = {
  [NotifyType.Success]: classNames(s.toast, s.primary),
  [NotifyType.Error]: classNames(s.toast, s.danger),
};

const CloseButton = ({
  closeToast,
}: { closeToast?: () => void }) => (
  <CloseIcon
    className={s.closeIcon}
    width='24'
    height='24'
    onClick={closeToast}
  />
);

export const ToastContainer: React.FC = () => (
  <ToastifyToastContainer
    autoClose={12000}
    hideProgressBar={true}
    closeOnClick={false}
    position="bottom-left"
    className={s.root}
    toastClassName={themes[NotifyType.Success]}
    closeButton={<CloseButton />}
    draggablePercent={40}
    progressClassName={s.toastifyProgressBar}
  />
);

export default ToastContainer;
